import { useQuery } from "@tanstack/react-query";
import { User } from "models/user";
import axiosInstance from "./axiosInstance";

export const useUserProfile = () => {
  const currentUserReturn = useQuery({
    queryKey: ["currentUser"],
    queryFn: async () => {
      const { data } = await axiosInstance.get<{ data: User }>(
        "api/User/current"
      );
      return data.data;
    },
    staleTime: 1000 * 60 * 5, // 5 phút
    refetchOnWindowFocus: false,
  });

  return currentUserReturn;
};
